import Vue from 'vue'
import VueDatetimeJs from 'vue-datetime-js'

Vue.component('datetime-picker', VueDatetimeJs)
